import React from 'react';
import { PersonalizationRequiredNotification } from './PersonalizationRequiredNotification';
import { BackInStockNotification } from './BackInStockNotification';
import { MovedToSavedForLaterNotification } from './MovedToSavedForLaterNotification';

export const ShoppingBagNotifications: React.FC = () => (
  <>
    <PersonalizationRequiredNotification />
    <BackInStockNotification />
    <MovedToSavedForLaterNotification />
  </>
);
